import {getAccessToken} from './sessionToken';

const localLink = "/";

function checkResponseCode(res, navigate) {
	
	//return;
	if (res.status === 200) { return; }
	if (res.status === 401) { navigate('/login'); }
}


export const generalItemUpload = async (itemId, selectedFile, navigate) => {

	try {
		const data = new FormData();
		data.append("itemId", itemId);
		data.append("generalfile", selectedFile);
		
		let res = await postFormData("utility/generalItemUpload", data, navigate);
		return res.data;
	} catch (err) {
		return null;
		console.log(err);
	}
}

export const getDataFreeAccess = (sendlink) => {
	//console.log(sendlink)
	return fetch(localLink + sendlink, {
		method: "GET",
		headers: { "Content-Type": "application/json"},
	}).then(res => {
		console.log(res);
		return res.json();
	});
}

export const postDataFreeAccess = (sendlink, obj) => {
	//console.log(sendlink)
	return fetch(localLink + sendlink, {
		method: "POST",
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify(obj),
	}).then(res => {
		return res.json();
	});
}


export const getData = (sendlink, navigate) => {
	//console.log(sendlink)
	return fetch(localLink + sendlink, {
		method: "GET",
		headers: { "Content-Type": "application/json" , "x-access-token": getAccessToken(navigate)},
	}).then(res => {
		checkResponseCode(res, navigate);
		return res.json();
	});
}
export const getWithBodyData = (sendlink, obj, navigate) => {
	//console.log(sendlink)
	return fetch(localLink + sendlink, {
		method: "GET",
		headers: { "Content-Type": "application/json" , "x-access-token": getAccessToken(navigate)},
		body: JSON.stringify(obj),
	}).then(res => {
		checkResponseCode(res, navigate);
		return res.json();
	});
}

export const postData = (sendlink, obj, navigate) => {
	//console.log(sendlink)
	return fetch(localLink + sendlink, {
		method: "POST",
		headers: {'Content-Type': 'application/json', "x-access-token": getAccessToken(navigate)},
		body: JSON.stringify(obj),
	}).then(res => {
		//console.log(res);
		checkResponseCode(res, navigate)
		return res.json();
	});
}


export const postFormData = (sendlink, str, navigate) => {
	//console.log(sendlink)
	return fetch(localLink + sendlink, {
		method: "POST",
		headers: {"x-access-token": getAccessToken(navigate)},
		body: str,
	}).then(res => {
		console.log(res);
		checkResponseCode(res, navigate)
		return res.json();
	});
}